import PropTypes from "prop-types";
import React from "react";
import { NipNavbar } from "../../Nip/Navbar";
import Sidebar from "../../Nip/Sidebar";

const TestWrapper = (props) => {
    const {logo, name, children } = props;

  return (
    <div className="container">
      <NipNavbar />
      <Sidebar />

      <div className="container-body2">
        <div className="inward-integration">
          <div className="inward-integration-header">
            <p className="inward-integration-header-title">
              {name} Integration
            </p>
            <p className="inward-integration-header-title2">
              This is your Test Environment
            </p>
          </div>
          <div className="inward-integration-testtop">
            <div className="inward-integration-testtop-right">
              <p className="inward-integration-testtop-right-title">
                {name} Test Integration
              </p>
              <p className="inward-integration-testtop-right-title2">
                Run tests, requests and responses, make API Calls and perform <br/>
                other related activities.
              </p>
            </div>
            <div className="inward-integration-testtop-left">
              <img src={logo} alt="inward logo" />
            </div>
          </div>
          <div>
              {children}
          </div>
        </div>
      </div>
    </div>
  );
};

TestWrapper.propTypes = {
  children: PropTypes.any,
  logo: PropTypes.any,
  name: PropTypes.any
}

export default TestWrapper;
